// app/assets/javascripts/widget_button.js.erb

import $ from 'jquery';
import './custom/contrasting_color';

window.$ = $;
window.jQuery = $;
